'use client';

import React from 'react';
import Image from 'next/image';
import classNames from 'classnames';
import { H2 } from '../WebsiteTypography';
import quotes from './quotes';
import styles from './styles.module.scss';

const firstFiveQuotes = quotes.slice(0, 5);
const secondFiveQuotes = quotes.slice(5, 10);

const Card = props => (
  <div className={styles.testimonialCard}>
    <div className={styles.authorSection}>
      <Image
        src={props.image}
        className={styles.authorImage}
        alt={props.name}
        width={40}
        height={40}
      />

      <div className={styles.authorInfo}>
        <div className={styles.name}>{props.name}</div>
        <div className={styles.position}>{props.position}</div>
      </div>
    </div>
    <div>
      <div className={styles.quoteText}>{`"${props.quote}"`}</div>
    </div>
  </div>
);

const Container = props => {
  return (
    <div className={styles.container}>
      <div className={classNames(styles.testimonialContainer, props.reverse && styles.reverse)}>
        {props.data.map((quote, i) => {
          return <Card key={i} {...quote} />;
        })}
      </div>
      <div className={classNames(styles.testimonialContainer, props.reverse && styles.reverse)}>
        {props.data.map((quote, i) => {
          return <Card key={i} {...quote} />;
        })}
      </div>
      <div className={classNames(styles.testimonialContainer, props.reverse && styles.reverse)}>
        {props.data.map((quote, i) => {
          return <Card key={i} {...quote} />;
        })}
      </div>
    </div>
  );
};

const Gradient = props => (
  <div
    className={classNames(styles.gradient, props.first && styles.first, props.last && styles.last)}
  />
);

const Testimonials = () => {
  return (
    <div style={{ marginTop: 100 }}>
      <div className={styles.sectionHeader}>
        <H2>Testimonials</H2>
      </div>
      <div className={styles.flexContainer}>
        <Gradient first />
        <Gradient last />
        <Container data={firstFiveQuotes} />
        <Container data={secondFiveQuotes} reverse />
      </div>
    </div>
  );
};

export default Testimonials;
